import { z } from "zod";
import { TimestampField } from "./common";

const HealthStatus = z.enum(["ok", "error", "degraded"]);
const DependencyStatus = z.enum(["ok", "error", "timeout"]);

const HealthResponse = z.object({
  status: HealthStatus,
  timestamp: TimestampField,
  service: z.string(),
  version: z.string(),
  stats: z
    .object({
      conversations: z.number().int(),
      threads: z.number().int(),
      messages: z.number().int(),
      uptime: z.number(),
      memory: z.object({ used: z.number(), total: z.number() }).partial(),
    })
    .partial()

    .optional(),
  diagnostics: z
    .object({
      database: z
        .object({ status: HealthStatus, responseTime: z.number() })
        .partial(),
      dependencies: z.array(
        z
          .object({
            name: z.string(),
            status: DependencyStatus,
            responseTime: z.number(),
          })
          .partial(),
      ),
    })
    .partial()

    .optional(),
});
export const schemas = {
  HealthResponse,
};

// oRPC Type Inference Support
// These types enable proper oRPC client generation and type inference

export type SchemaTypes = {
  [K in keyof typeof schemas]: z.infer<(typeof schemas)[K]>;
};

// Re-export for convenient access
export type * from "zod";
